import { combineReducers } from 'redux';
import progress from "./reducers/progressReducer";

export default combineReducers({
  progress
});